import React from 'react';
import { Card } from '@/components/ui/card';
import type { AdminSection } from './adminSections';

interface AdminSectionCardProps {
  section: AdminSection;
  onOpen: (path: string) => void;
}

const AdminSectionCard: React.FC<AdminSectionCardProps> = ({ section, onOpen }) => {
  const Icon = section.icon;

  return (
    <Card
      className="h-full cursor-pointer transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md"
      onClick={() => onOpen(section.path)}
    >
      <div className="p-4 pb-6">
        <div className="mb-4 flex items-center">
          <div className="mr-4 grid size-12 shrink-0 place-items-center rounded-md bg-primary/15 text-primary">
            <Icon className="size-6" strokeWidth={1.8} aria-hidden="true" />
          </div>
          <h3 className="revy-cjk text-base font-semibold leading-[1.5]">
            {/* The MUI card was a bare onClick <div>: clickable, but with no
                control a keyboard or screen reader could reach. The card click
                is kept as-is and the title becomes the real control; the stop
                keeps one press from navigating twice. */}
            <button
              type="button"
              onClick={(event) => {
                event.stopPropagation();
                onOpen(section.path);
              }}
              className="rounded-sm text-left focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring"
            >
              {section.title}
            </button>
          </h3>
        </div>
        <p className="revy-cjk text-sm leading-[1.6] text-muted-foreground">
          {section.description}
        </p>
      </div>
    </Card>
  );
};

export default AdminSectionCard;
